export default __webpack_public_path__ + "static/media/fundamentos-azure.efa0fa5a.png";